import Schema from './schema'
import {SRC_GEN} from '../Data/typeDirs'

class GenericSource extends Schema {

  constructor(p){
    super(p)
    this.typeDir = GenericSource.getTypeDir()
    this.ext = GenericSource.getExt()
  }

  static getExt(){
    return 'source.json'
  }

  static getTypeDir(){
    return SRC_GEN
  }

  getGenericSource(){
    return Schema.tryGetAttr(SRC_GEN, x=>this.content.content[0].source)
  }

  setGenericSource(source){
    this.content = {
      0: {
        source
      }
    }
  }
}
if( typeof window !== 'undefined' ) window._ms_GenericSource = GenericSource


export default GenericSource
